/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { searchSubject } from 'utils/services/search';

const SearchBoxContainer = React.createClass({
	propTypes: {
		initialTerm: React.PropTypes.string,
		isSearchPage: React.PropTypes.bool,
	},
	getInitialState() {
		return {
			term: this.props.initialTerm,
		};
	},
	// when the component is attached to the DOM
	componentDidMount() {

	},
	componentWillUnmount() {
    // SearchSubject.onCompleted();
	},
	onKeyPress(evt) {
		if (evt.charCode === 13) {
			this.submit();
		}
	},
	onSubmit(evt) {
		evt.preventDefault();
		this.submit();
	},
	onReset() {
		// when user click on the X icon -> empty search field and close the dropdown if it open
		this.setState({ term: '' });
		searchSubject.onNext({});
	},
	onChange(evt) {
		const newState = { term: evt.target.value };
		this.setState(newState);
		searchSubject.onNext(newState);
	},
	submit() {
		if (!this.props.isSearchPage) {
			window.location.href = `/search.aspx?q=${this.state.term}`;
		}
	},
	render() {
		const term = this.state.term;
		return (
			<form className="navbar-form navbar-right" onSubmit={this.onSubmit}>
				<div className="form-group input-search-wrap">
					<input type="text" className="form-control input-search" placeholder="cerca" value={term} onChange={this.onChange} onKeyPress={this.onKeyPress} />
					{term.length > 0 ? (
						<i className="material-icons mi-close" onClick={this.onReset}>&#xE5CD;</i>
					) :
						<i className="material-icons mi-search">&#xE8B6;</i>
					}
				</div>
			</form>
		);
	},
});
export default SearchBoxContainer;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/components/SearchBoxContainer/searchBoxContainer.js
 **/